import React, { forwardRef } from "react";

import classNames from "classnames";

import { StyledButtonGroup } from "./Styles";

export const ButtonGroup = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div"> & { invalid?: boolean }
>(({ children, className, invalid, ...rest }, ref) => (
  <StyledButtonGroup
    ref={ref}
    className={classNames("c-btn-group", className)}
    $invalid={invalid}
    {...rest}
  >
    {children}
  </StyledButtonGroup>
));

ButtonGroup.displayName = "ButtonGroup";
